import { useCallback, useEffect, useState } from 'react';
import { useAdminApi, ApiError } from '../../../Admin/shared/adminApi';
import type { ReferralOverview } from './types';

export interface ReferralOverviewFilters {
  from?: string;
  to?: string;
}

export function useReferralOverview(filters: ReferralOverviewFilters) {
  const { request } = useAdminApi();
  const [data, setData] = useState<ReferralOverview | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      setData(
        await request<ReferralOverview>({
          env: 'prod',
          path: '/admin/analytics/referrals/overview',
          query: filters as Record<string, string | number | undefined>,
        }),
      );
    } catch (e) {
      setError(e instanceof ApiError ? e.message : 'Failed to load referral overview');
      setData(null);
    } finally {
      setLoading(false);
    }
  }, [request, JSON.stringify(filters)]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    void load();
  }, [load]);

  return { data, error, loading, reload: load };
}
